
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_z5ylv_66",
  "button": "awsui_button_vjswe_z5ylv_70",
  "variant-normal": "awsui_variant-normal_vjswe_z5ylv_132",
  "disabled": "awsui_disabled_vjswe_z5ylv_150",
  "variant-primary": "awsui_variant-primary_vjswe_z5ylv_157",
  "variant-link": "awsui_variant-link_vjswe_z5ylv_182",
  "variant-icon": "awsui_variant-icon_vjswe_z5ylv_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_z5ylv_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_z5ylv_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_z5ylv_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_z5ylv_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_z5ylv_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_z5ylv_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_z5ylv_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_z5ylv_418",
  "variant-control-group-action-error": "awsui_variant-control-group-action-error_vjswe_z5ylv_518",
  "variant-control-group-action-warning": "awsui_variant-control-group-action-warning_vjswe_z5ylv_522",
  "button-no-text": "awsui_button-no-text_vjswe_z5ylv_526",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_z5ylv_530",
  "full-width": "awsui_full-width_vjswe_z5ylv_533",
  "button-compact": "awsui_button-compact_vjswe_z5ylv_550",
  "icon-left": "awsui_icon-left_vjswe_z5ylv_579",
  "icon-right": "awsui_icon-right_vjswe_z5ylv_584",
  "icon": "awsui_icon_vjswe_z5ylv_579",
  "link": "awsui_link_vjswe_z5ylv_603",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_z5ylv_603"
};
  